<template>
    <flex-container direction="column" :gap="Size.sm">
        <input-group v-model="newEmail" :schema="string().email()">
            <template #input>
                <flex-container align-items="center" no-wrap>
                    <text-input
                        placeholder="bijv. info@bedrijf.nl, collega@bedrijf.nl"
                        @keydown.enter="addEmailAddress"
                    >
                        <template #prefix>
                            <svg-icon
                                :icon="AtIcon"
                                :size="IconSize.sm"
                                color="gray-500"
                                is-custom-icon
                            />
                            <span class="screen-reader">
                                E-mail Address
                            </span>
                        </template>
                    </text-input>
                    <button-text
                        :disabled="!inputIsValid"
                        @click="addEmailAddress"
                    >
                        <svg-icon
                            :icon="PlusIcon"
                            is-custom-icon
                            :size="IconSize.md"
                        />
                        <span>
                            Toevoegen
                        </span>
                    </button-text>
                </flex-container>
            </template>
        </input-group>
        <chip-container
            v-if="emails.length > 0"
        >
            <chip-label
                v-for="(email, index) in emails"
                :key="index"
                size="lg"
                :background-color="'gray-50'"
                :border-color="'gray-300'"
            >
                <text-decorator :color="'gray-800'">
                    {{ email }}
                </text-decorator>
                <button-plain-icon
                    :size="IconSize.sm"
                    :icon="XmarkIcon"
                    :color="'gray-400'"
                    is-custom-icon
                    @click="removeEmailAddress(index)"
                />
            </chip-label>
        </chip-container>
    </flex-container>
</template>

<script setup lang="ts">
    import XmarkIcon from '@keyvue/one-awesome-icons/icons/regular/xmark.svg?component';
    import PlusIcon from '@keyvue/one-awesome-icons/icons/regular/plus.svg?component';
    import AtIcon from '@keyvue/one-awesome-icons/icons/regular/at.svg?component';

    import { IconSize, Size } from '@keyvue/one-ui';
    import { string } from 'yup';
    import { computed, inject, onMounted, ref } from 'vue';
    import { onBeforeRouteUpdate } from 'vue-router';

    const newEmail = ref<string>('');
    const emails = ref<string[]>([]);

    const inputBindings: {
        value: {
            value: string[]
        },
        setValue: (newValue: any) => void,
    } | undefined = inject('input-bindings');

    onMounted(() => {
        newEmail.value = '';
    });

    onBeforeRouteUpdate(() => {
        newEmail.value = '';
    });

    function addEmailAddress() {
        if (newEmail.value === '') {
            return;
        }

        if (!string().email().isValidSync(newEmail.value)) {
            return;
        }

        emails.value.push(newEmail.value);
        inputBindings?.setValue(emails.value);
        newEmail.value = '';
    }

    function removeEmailAddress(index: number) {
        emails.value.splice(
            index,
            1,
        );

        inputBindings?.setValue(emails.value);
    }

    const inputIsValid = computed(() => {
        if (newEmail.value === '') {
            return false;
        }

        return string().email().isValidSync(newEmail.value);
    });
</script>
